<template>
    <div id="setting">
        <!-- <div class="top_title fixed">设置</div> -->
        <ul class="setting_list">
            <li class="setting_item" @click="gotoTarget(0)">
                <span>用户协议</span>
                <van-icon name="arrow" />
            </li>
            <li class="setting_item" @click="gotoTarget(1)">
                <span>隐私政策</span>
                <van-icon name="arrow" />
            </li>
            <li class="setting_item" @click="gotoTarget(2)">
                <span>儿童个人信息保护规则及监护人须知</span>
                <van-icon name="arrow" />
            </li>
            <li class="setting_item" @click="gotoTarget(3)">
                <span>第三方服务共享清单</span>
                <van-icon name="arrow" />
            </li>
            <li class="setting_item" @click="logout">
                <span>退出登录</span>
                <van-icon name="arrow" />
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                list: ['agreement','policy','children','thirdparty']
            }
        },
        methods: {
            gotoTarget(i) {
                this.$router.push({
                    name: this.list[i]
                })
            },
            logout() {
                var that = this
                this.$RModal.logout({
                    onSuccess: () => {
                        that.$toast({
                        message: '退出登录成功',
                        duration: "500",
                        onClose: () => {
                            that.$store.dispatch('logout')
                        }
                       })
                    }
                })
            }
        },
    }
</script>
<style lang="less" scoped>
    #setting {
        padding-top: 1rem;
        .setting_list {
            margin-top: 1.5rem;
        }
        .setting_item {
            padding: 1rem 1rem 1rem 2rem;
            margin-bottom: 1rem;
            background-color: #fff;
            border-radius: 0.4rem;
            word-break: break-all;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;

            span {
                padding-right: 1.2rem;
                flex: 1;
                word-break: break-all;
                font-size: 1.5rem;
            }

            .van-icon {
                font-size: 2.2rem;
                color: #aaa;
            }

            &:hover {
                color: var(--theme);

                .van-icon {
                    color: var(--theme);
                }
            }
        }
    }
</style>